
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/key-workers",
      function () {
        return require("private-next-pages/key-workers.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/key-workers"])
      });
    }
  